"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseMetaobjectReferenceList = exports.parseMetaobjectReference = exports.parseMetaobject = void 0;
var parseMetaobject = function (field, isJson) {
    return field.value ?
        (isJson ? JSON.parse(field.value) : field.value) :
        null;
};
exports.parseMetaobject = parseMetaobject;
// Copied out of the old way, needed a little an extra type check to make sure the reference was a metaobject
var parseMetaobjectReference = function (field, isJson) {
    var _a;
    var reference = field === null || field === void 0 ? void 0 : field.reference;
    return ((_a = reference.field) === null || _a === void 0 ? void 0 : _a.value) ?
        (isJson ? JSON.parse(reference.field.value) : reference.field.value) :
        null;
};
exports.parseMetaobjectReference = parseMetaobjectReference;
// Looks complicated but this does the same thing but on a list!
var parseMetaobjectReferenceList = function (field) {
    var _a, _b, _c, _d;
    return ((_d = (_c = (_b = (_a = field === null || field === void 0 ? void 0 : field.references) === null || _a === void 0 ? void 0 : _a.nodes) === null || _b === void 0 ? void 0 : _b.filter(function (n) { return !!n; })) === null || _c === void 0 ? void 0 : _c.map(function (n) { var _a; return ((_a = n.field) === null || _a === void 0 ? void 0 : _a.value) ? JSON.parse(n.field.value) : null; })) === null || _d === void 0 ? void 0 : _d.filter(function (n) { return !!n; })) || [];
};
exports.parseMetaobjectReferenceList = parseMetaobjectReferenceList;
